export default __webpack_public_path__ + "static/media/odznaka-4.431433bd.svg";